//import * as S from '../../components/DadosCadastroPF/styles'
import * as S from '../../styles/transacao-negada'
import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import pedidos from '../../api/pedidos'
import Loader from '../../components/Loader'
import { useToast } from '../../hooks/toast'
import TextField from '../../components/TextField'
import Header from '../../components/Header'

import Select from '../../components/SelectSingle'
import { Breadcrumb, BreadcrumbItem } from '../../styles/breadcrumb'
import { useLocation, useParams } from 'react-router-dom'
import { onlyNumber, convertDecimalCurrency } from '../../utils/utils'
import {
  formatCardNumber,
  validateCard,
  validateCVV
} from '../../utils/creditCardValidation'
import Footer from '../../components/Footer'
import * as Yup from 'yup'
import * as Utils from '../../utils/utils'
import { monthsList, yearsList } from './cardDate'
import { getCardFlag } from '../../utils/creditCardValidation'
import ChangePaymentModal from '../../components/ChangePaymentModal'
import { getLocalStorageLog } from '../../utils/traceLogAcessos'

function DadosPagamento() {
  //const [idpedido] = useQueryParam('idpedido', StringParam)
  const { idpedido } = useParams()
  const [loader, setLoader] = useState(false)
  const { addToast } = useToast()
  const [arrayMonths, setMonths] = useState([])
  const [inputErrors, setInputErrors] = useState(false)
  const router = useHistory()
  const [isCardNumberValid, setIsCardNumberValid] = useState(true)
  const [isCVVNumberValid, setIsCVVNumberValid] = useState(true)
  const [cardFlag, setCardFlag] = useState(null)
  const [abrirBoleto, setAbrirBoleto] = useState(false)

  const [boletoHabilitado, setBoletoHabilitado] = useState(false)
  const [BoletoAVistaHabilitado, setBoletoAVistaHabilitado] = useState(false)
  const [BoletoFaturadoHabilitado, setBoletoFaturadoHabilitado] =
    useState(false)

  const [boletoFaturadoValue, setBoletoFaturadoValue] = useState()

  const [localData, setLocalData] = useState({
    anoValidade: '',
    mesValidade: ''
  })

  const [localDataBoleto, setLocalDataBoleto] = useState()
  const [localDataFaturado, setLocalDataFaturado] = useState()

  const [creditCardData, setCreditCardData] = useState({
    anoValidade: '',
    mesValidade: ''
  })

  const [showModal, setShowModal] = useState(false)
  const [confirmChange, setConfirmChange] = useState(false)

  const history = useHistory()

  const boletoFaturadoOptions =
    localData.BoletoFaturado &&
    Object.entries(JSON.parse(localData.BoletoFaturado)).map((item) => {
      return {
        value: item[0] + '|' + item[1],
        label: item[1]
      }
    })

  // const idFormaBoletofaturado = boletoFaturadoValue?.split('|')[0]
  // const idCondicaoBoletofaturado = boletoFaturadoValue?.split('|')[1]
  // const valorBoletofaturado = boletoFaturadoValue?.split('|')[2]
  // const quantidadeParcelasBoletofaturado = boletoFaturadoValue?.split('|')[3]
  // const percentualDescontoBoletofaturado = boletoFaturadoValue?.split('|')[4]
  // const percentualJurosBoletofaturado = boletoFaturadoValue?.split('|')[5]
  // const descricaoBoletofaturado = boletoFaturadoValue?.split('|')[6]

  const handleBoletoFaturadoChange = (e) => {
    const idFormaBoletofaturado = e?.split('|')[0]
    const idCondicaoBoletofaturado = e?.split('|')[1]
    const valorBoletofaturado = e?.split('|')[2]
    const quantidadeParcelasBoletofaturado = e?.split('|')[3]
    const percentualDescontoBoletofaturado = e?.split('|')[4]
    const percentualJurosBoletofaturado = e?.split('|')[5]
    const descricaoBoletofaturado = e?.split('|')[6]
    const condicaoPagamento = e?.split('|').slice(0, -1).join('|')

    setLocalDataFaturado((prev) => ({
      ...prev,
      BoletoDescricao: descricaoBoletofaturado,
      IdCondicaoBoleto: idCondicaoBoletofaturado,
      IdFormaBoleto: idFormaBoletofaturado,
      BoletoValorPedido: valorBoletofaturado,
      BoletoPercentualDesconto: percentualDescontoBoletofaturado,
      CondicaoPagamentoBoleto: condicaoPagamento
    }))
  }

  const handleBoletoAVistaChange = () => {
    setLocalDataBoleto((prev) => ({
      ...prev,
      CondicaoBoleto: 1
    }))
  }

  const onBlurCardNumberChange = () => {
    //Validação e Mensagem de erro ao sair input
    if (creditCardData?.NovoCartaoNumero?.length > 0)
      validateCard(creditCardData?.NovoCartaoNumero)
        ? setIsCardNumberValid(true)
        : setIsCardNumberValid(false)
  }

  const handleChangeCheckbox = (event, name) => {
    setBoletoAVistaHabilitado(false)
    setBoletoFaturadoHabilitado(false)
    let value = 0

    if (name == 'BoletoAVista' || name == 'BoletoFaturadoCheck') {
      setBoletoHabilitado(event.target.checked)
    }

    if (event.target.checked && name == 'BoletoAVista') {
      setBoletoAVistaHabilitado(true)
      // fetch(idpedido)
      setLocalDataBoleto((prev) => ({
        ...prev,
        ...localData,
        CondicaoBoleto: 1
      }))
      // console.log('local', localData)
      value = 1
    }

    if (event.target.checked && name == 'BoletoFaturadoCheck') {
      setBoletoFaturadoHabilitado(true)
      setLocalDataFaturado((prev) => ({
        ...prev,
        ...localData,
        CondicaoBoleto: 2,
        CondicaoPagamentoBoleto: boletoFaturadoValue
      }))

      value = 2
    }

    // let newObject = Object.assign({}, localData, {
    //   [name]: value
    // })

    // setLocalData(newObject)
  }

  // console.log('BoletoGeral', boletoHabilitado)
  // console.log('BoletoAVista', BoletoAVistaHabilitado)
  // console.log('BoletoFaturadoCheck', BoletoFaturadoHabilitado)
  // console.log(boletoFaturadoOptions)

  const formaPagamento = () => {
    let forma = ''

    if (!boletoHabilitado) {
      forma = 'Cartão de Crédito'
    } else if (!!BoletoFaturadoHabilitado) {
      forma = 'Boleto Faturado'
    } else {
      forma = 'Boleto à Vista'
    }

    return forma
  }

  const onChange = (value, field) => {
    // if (field == 'BoletoAVista' || field == 'BoletoFaturado') {
    //     setBoletoHabilitado(true);
    // }

    // if (field == 'BoletoAVista') {
    //         value = 1;
    // } else if (field == 'BoletoFaturado') {
    //         field = 'BoletoAVista';
    //         value = 2;
    // }

    if (localData[field]) {
      setLocalData((prev) => ({
        ...prev,
        [field]: value
      }))

      setInputErrors({
        ...inputErrors,
        [field]: ''
      })
    } else {
      let newObject = Object.assign({}, localData, {
        [field]: value
      })

      setLocalData(newObject)
    }
  }

  const onChangeCreditCard = (value, field) => {
    if (creditCardData[field]) {
      setCreditCardData((prev) => ({
        ...prev,
        [field]: value
      }))

      setInputErrors({
        ...inputErrors,
        [field]: ''
      })
    } else {
      let newObject = Object.assign({}, creditCardData, {
        [field]: value,
        ...localData
      })

      // setLocalData(newObject)
      setCreditCardData(newObject)
    }
  }

  const openModal = (id) => {
    setShowModal((prev) => !prev)
  }

  const maxLengthCardNumber = () => {
    if (cardFlag === 'amex') return 17
    else if (cardFlag === 'diners_club') return 16
    else return 19
  }

  const formData = {
    NovoCartaoNumero: creditCardData.NovoCartaoNumero,
    CartaoNome: creditCardData.CartaoNome,
    CartaoCodigoSeguranca: creditCardData.CartaoCodigoSeguranca,
    mesValidade: creditCardData?.mesValidade,
    anoValidade: creditCardData?.anoValidade
  }

  Yup.addMethod(Yup.string, 'creditCardFlag', function (errorMessage) {
    return this.test(`card-flag`, errorMessage, function () {
      const { path, createError } = this

      return (
        cardFlag !== undefined || createError({ path, message: errorMessage })
      )
    })
  })

  Yup.addMethod(Yup.string, 'creditCardNumber', function (errorMessage) {
    return this.test(`card-number`, errorMessage, function () {
      const { path, createError } = this

      return (
        isCardNumberValid === true ||
        createError({ path, message: errorMessage })
      )
    })
  })

  Yup.addMethod(Yup.string, 'creditCardCVV', function (errorMessage) {
    return this.test(`card-cvv`, errorMessage, function () {
      const { path, createError } = this

      return (
        isCVVNumberValid === true ||
        createError({ path, message: errorMessage })
      )
    })
  })

  const schemaValidation = Yup.object().shape({
    NovoCartaoNumero: Yup.string()
      .creditCardNumber('Número Inválido')
      .creditCardFlag('Bandeira não suportada')
      .required('Campo obrigatório*'),
    // .min(14, 'Número inválido')
    CartaoNome: Yup.string().required('Campo obrigatório*'),
    CartaoCodigoSeguranca: Yup.string()
      .creditCardCVV('CVV Inválido')
      .required('Campo obrigatório*'),
    mesValidade: Yup.string().required('Campo obrigatório*'),
    anoValidade: Yup.string().required('Campo obrigatório*')
  })

  const handleCVVChange = (e) => {
    const { name, value } = e.target

    setCreditCardData((prev) => ({
      ...prev,
      [name]: onlyNumber(value)
    }))

    if (creditCardData?.CartaoNumero?.length > 0) {
      validateCVV(value, cardFlag)
        ? setIsCVVNumberValid(true)
        : setIsCVVNumberValid(false)
    }

    setInputErrors({
      ...inputErrors,
      [name]: ''
    })
  }

  // console.log('err', inputErrors)
  // console.log(creditCardData.mesValidade, creditCardData.anoValidade)
  // console.log('cardFlagNumber', cardFlag)

  const changeCardFlagToIdPagamento = () => {
    let idPagamento

    switch (cardFlag) {
      case 'visa':
        idPagamento = '1|Cartão Visa'
        break
      case 'mastercard':
        idPagamento = '2|Cartão MasterCard'
        break
      case 'diners':
        idPagamento = '3|Cartão Diners'
        break
      case 'amex':
        idPagamento = '4|Cartão Amex'
        break
      case 'elo':
        idPagamento = '14|Cartão Elo'
        break
      default:
        break
    }

    return idPagamento
  }

  const fetch = async (idpedido) => {
    setLoader(true)

    let res = await pedidos.GetDadosPagamentos(idpedido).catch((err) => {
      // console.log(err)
      addToast({
        type: 'error',
        title: 'Erro ao mostrar os dados'
      })
      return err
    })

    setLocalData(res)
    // console.log('res pedido :', res)
    setLoader(false)
    setMonths({
      1: 'Janeiro',
      2: 'Fevereiro',
      3: 'Março',
      4: 'Abril',
      5: 'Maio',
      6: 'Junho',
      7: 'Julho',
      8: 'Agosto',
      9: 'Setembro',
      10: 'Outubro',
      11: 'Novembro',
      12: 'Dezembro'
    })
  }

  const location = useLocation()

  useEffect(() => {
    getLocalStorageLog(location.pathname)
    fetch(idpedido)
  }, [])

  useEffect(() => {
    if (!!confirmChange) {
      creditPost()
    }
  }, [confirmChange])

  useEffect(() => {
    if (localData.MudouFormaPagamento && abrirBoleto) {
      window.open(
        `${process.env.REACT_APP_URL_MAIN}/bradesco/gerarboleto/?idpedido=${localData.IdPedido}`
      )
    }
  }, [abrirBoleto])

  useEffect(() => {
    if (localData.MensagemErro) {
      addToast({
        type: 'error',
        title: 'Ocorreu um erro ao carregar dados de pagamento',
        description: `${localData?.MensagemErro}`,
        time: 7000
      })
      setTimeout(() => {
        router.push('/meus-pedidos')
      }, 4000)
    }
  }, [localData])

  const anoAtual = new Date().getFullYear()

  useEffect(() => {
    creditCardData.anoValidade == anoAtual &&
      setCreditCardData({
        ...creditCardData,
        mesValidade: monthsList(creditCardData.anoValidade)[1].value
      })
  }, [creditCardData.anoValidade])

  useEffect(() => {
    setCreditCardData((prev) => ({
      ...prev,
      IdPagamento: changeCardFlagToIdPagamento()
    }))
  }, [cardFlag])

  useEffect(() => {
    if (!!BoletoFaturadoHabilitado) {
      setBoletoFaturadoValue(boletoFaturadoOptions[0]?.value)
      handleBoletoFaturadoChange(boletoFaturadoOptions[0]?.value)
    }
  }, [BoletoFaturadoHabilitado])

  const creditPost = async () => {
    if (!!isCVVNumberValid && !!isCardNumberValid) {
      // console.log('ENVIAR CREDITO', creditCardData)

      let res = await pedidos.SalvarDadosPagamento(creditCardData)

      if (res) {
        addToast({
          type: 'success',
          title: 'Dados de pagamento alterado com sucesso!'
        })
        router.push('/meus-pedidos')
      } else {
        addToast({
          type: 'error',
          title: 'Erro ao alterar dados de pagamento'
        })
      }
      setLoader(false)
    }
  }

  const handleSubmitCredit = async () => {
    setLoader(true)

    try {
      await schemaValidation.validate(formData, {
        abortEarly: false
      })

      setCreditCardData((prev) => ({
        ...prev,
        ...formData
      }))

      console.log({ creditCardData, formData })

      openModal()
      // if (!!confirmChange) {
      //   console.log('ENVIAR CREDITO', creditCardData)
      // }

      // console.log(!!isCVVNumberValid && !!isCardNumberValid)

      setLoader(false)
      setConfirmChange(false)
      // if (!!isCVVNumberValid && !!isCardNumberValid) {
      //   let res = await pedidos.SalvarDadosPagamento(creditCardData)

      //   if (res) {
      //     addToast({
      //       type: 'success',
      //       title: 'Dados de pagamento alterado com sucesso!'
      //     })
      //     router.push('/meus-pedidos')
      //   }
      //   setLoader(false)
      // }
    } catch (err) {
      if (err) setLoader(false)

      const startingPoint = document.getElementById('starting-point')

      startingPoint.scrollIntoView({ behavior: 'smooth' })

      if (err instanceof Yup.ValidationError) {
        const emptyField = Object.values(err.value).every(
          (value) => value !== '' || value !== undefined
        )

        if (emptyField) {
          addToast({
            type: 'error',
            title: 'Todos os campos devem ser preenchidos'
          })

          const errorArray = err.inner.map(({ path, message }) => {
            return {
              name: path,
              message: message
            }
          })

          const objeto = errorArray.reduce((acc, d) => {
            // acc[d.name] = d.message
            acc[d.name] = d.message

            return acc
          }, {})

          setInputErrors(objeto)
        } else {
          setLoader(false)

          err.inner.map((error) => {
            addToast({
              type: 'error',
              title: `${error.message}`
            })
          })
        }
      }
    }
  }

  const handleSubmitBoleto = async () => {
    if (BoletoAVistaHabilitado === true) {
      setLocalDataBoleto((prev) => ({
        ...prev
        // ...formData
      }))
    } else {
      setLocalData((prev) => ({
        ...prev
        // ...formData
      }))
    }
    setLoader(true)

    try {
      // console.log('ENVIAR BOLETO VISTA', {
      //   ...localDataBoleto,
      //   BoletoFaturado: '',
      //   CartaoMensagemDtef: null
      // })
      // console.log('ENVIAR BOLETO FATURADO', {
      //   ...localDataFaturado,
      //   BoletoFaturado: '',
      //   CartaoMensagemDtef: null
      // })

      let res =
        BoletoAVistaHabilitado === true
          ? await pedidos.SalvarDadosPagamento({
              ...localDataBoleto,
              BoletoFaturado: '',
              CartaoMensagemDtef: ''
            })
          : await pedidos.SalvarDadosPagamento({
              ...localDataFaturado,
              BoletoFaturado: '',
              CartaoMensagemDtef: ''
            })

      if (res) {
        let newObject = Object.assign({}, localData, {
          MudouFormaPagamento: true
        })

        setLocalData(newObject)

        if (!!BoletoAVistaHabilitado) setAbrirBoleto(true)

        addToast({
          type: 'success',
          title: 'Dados de pagamento alterado com sucesso!'
        })
        router.push('/meus-pedidos')
        //return response.json
      } else {
        addToast({
          type: 'error',
          title: 'Erro ao alterar dados de pagamento. Tente novamente'
        })
      }
      setLoader(false)
    } catch (error) {
      setLoader(false)

      addToast({
        type: 'error',
        title: 'Erro ao alterar dados de pagamento. Tente novamente'
      })
    }
  }

  const salvarDados = async (e) => {
    setLoader(true)

    try {
      if (!boletoHabilitado) {
        await schemaValidation.validate(formData, {
          abortEarly: false
        })

        setCreditCardData((prev) => ({
          ...prev,
          ...formData
        }))

        // console.log('ENVIAR CREDITO', creditCardData)
      } else {
        setLocalData((prev) => ({
          ...prev
          // ...formData
        }))

        // console.log('ENVIAR BOLETO', localData)
      }

      // console.log(formData)

      if (!!isCVVNumberValid && !!isCardNumberValid) {
        // let res = await pedidos.SalvarDadosPagamento(localData)

        // if (res) {
        //   let newObject = Object.assign({}, localData, {
        //     MudouFormaPagamento: true
        //   })

        //   setLocalData(newObject)

        //   let boletoAVista = localData.BoletoAVista == 1
        //   let boletoFaturado = localData.BoletoAVista == 2
        //   let boleto = boletoAVista || boletoFaturado

        //   if (boleto) setAbrirBoleto(boleto)

        //   addToast({
        //     type: 'success',
        //     title: 'Dados de pagamento alterado com sucesso!'
        //   })
        //   router.push('/meus-pedidos')
        //   //return response.json
        // }
        setLoader(false)
        setConfirmChange(false)
      }

      //console.log('resultado: ', res);
    } catch (err) {
      if (err) setLoader(false)

      const startingPoint = document.getElementById('starting-point')

      startingPoint.scrollIntoView({ behavior: 'smooth' })

      if (err instanceof Yup.ValidationError) {
        const emptyField = Object.values(err.value).every(
          (value) => value !== '' || value !== undefined
        )

        if (emptyField) {
          addToast({
            type: 'error',
            title: 'Todos os campos devem ser preenchidos'
          })

          const errorArray = err.inner.map(({ path, message }) => {
            return {
              name: path,
              message: message
            }
          })

          const objeto = errorArray.reduce((acc, d) => {
            // acc[d.name] = d.message
            acc[d.name] = d.message

            return acc
          }, {})

          setInputErrors(objeto)
        } else {
          setLoader(false)

          err.inner.map((error) => {
            addToast({
              type: 'error',
              title: `${error.message}`
            })
          })
        }
      }
    }
  }

  return (
    <>
      {!!loader && <Loader />}

      <ChangePaymentModal
        showModal={showModal}
        setShowModal={setShowModal}
        handleSubmitCredit={handleSubmitCredit}
        handleSubmitBoleto={handleSubmitBoleto}
        formaPagamento={formaPagamento()}
        setConfirmChange={setConfirmChange}
      />

      <Header />

      <div>
        <S.PageContent className="page-content">
          <S.Wrapper className="wrapper">
            <Breadcrumb>
              <BreadcrumbItem>Meus Pedidos</BreadcrumbItem>
              <BreadcrumbItem>Alteração de Dados de Pagamento</BreadcrumbItem>
            </Breadcrumb>
            <S.PerfilTitleH2 className="perfil-title">
              Alteração dos dados de pagamento para pedidos com transação negada
            </S.PerfilTitleH2>
            <S.PerfilBox className="perfil-box">
              <S.PerfilBoxP className="description">
                Verifique as informações abaixo. Caso esteja incorretas,
                corrigir. Depois clique em confirmar e seu pedido será enviado
                novamente para pagamento. Caso queira alterar a forma de
                pagamento de seu pedido, basta selecionar a opção disponível
                abaixo e depois confirmar. Obs: Caso selecione boleto à vista,
                será aberta uma nova página direcionando ao boleto. Em caso de
                problemas, consulte o pedido e clique em 2ª via de boleto.
              </S.PerfilBoxP>
              <S.TransacaoNegadaContent classname="transacao-negada-content">
                <S.TransacaoNegadaSubTitleBox classname="transacao-negada-subtitle-box">
                  <S.TransacaoNegadaSubTitleH5
                    className="transacao-negada-subtitle"
                    id="starting-point"
                  >
                    Dados do Cartão
                  </S.TransacaoNegadaSubTitleH5>
                </S.TransacaoNegadaSubTitleBox>

                <S.TransacaoNegadaNegadaColums classname="transacao-negada-columns">
                  <S.TransacaoNegadaNegadaColum className="transacao-negada-column">
                    <strong>Bandeira do Cartão:</strong>
                  </S.TransacaoNegadaNegadaColum>
                  <S.TransacaoNegadaNegadaColum className="transacao-negada-column">
                    <Select
                      options={
                        localData &&
                        localData.ArrayDadosPagamento &&
                        Object.entries(
                          JSON.parse(localData.ArrayDadosPagamento)
                        ).map((item) => {
                          return {
                            value: item[0] + '|' + item[1],
                            label: item[1]
                          }
                        })
                      }
                      labelFor="Bandeira do Cartão"
                      disabled={
                        boletoHabilitado ||
                        creditCardData.NovoCartaoNumero?.length > 0
                      }
                      value={creditCardData.IdPagamento}
                      onChange={(e) => {
                        onChangeCreditCard(e.target.value, 'IdPagamento')
                        // console.log('bandeira', e.target.value)
                      }}
                      className="form-select"
                    />
                  </S.TransacaoNegadaNegadaColum>
                </S.TransacaoNegadaNegadaColums>
                <S.TransacaoNegadaNegadaColums classname="transacao-negada-columns">
                  <S.TransacaoNegadaNegadaColum className="transacao-negada-column">
                    <strong>Nome do cartão:</strong>
                  </S.TransacaoNegadaNegadaColum>
                  <S.TransacaoNegadaNegadaColum className="transacao-negada-column">
                    <TextField
                      name="CartaoNomeInput"
                      disabled={boletoHabilitado}
                      maxLength={40}
                      placeholder="Nome do cartão"
                      value={localData.CartaoNome}
                      error={inputErrors.CartaoNome}
                      onChange={(e) =>
                        // onChangeCreditCard(
                        //   Utils.noSpecialChars(e.target.value).replace(
                        //     /[0-9]/g,
                        //     ''
                        //   ),
                        //   'CartaoNome'
                        // )
                        setLocalData((prev) => ({
                          ...prev,
                          CartaoNome: e.target.value
                        }))
                      }
                    />
                  </S.TransacaoNegadaNegadaColum>
                </S.TransacaoNegadaNegadaColums>
                <S.TransacaoNegadaNegadaColums class="transacao-negada-columns">
                  <S.TransacaoNegadaNegadaColum class="transacao-negada-column">
                    <strong>Cartão Informado:</strong>
                  </S.TransacaoNegadaNegadaColum>
                  <S.TransacaoNegadaNegadaColum class="transacao-negada-column">
                    <TextField
                      name="CartaoNumero"
                      placeholder="Número do cartão"
                      value={localData.CartaoNumero}
                      disabled="disabled"
                    />
                  </S.TransacaoNegadaNegadaColum>
                </S.TransacaoNegadaNegadaColums>
                <S.TransacaoNegadaNegadaColums classname="transacao-negada-columns">
                  <S.TransacaoNegadaNegadaColum className="transacao-negada-column">
                    <strong>Numero do cartão:</strong>
                  </S.TransacaoNegadaNegadaColum>
                  <S.TransacaoNegadaNegadaColum
                    className="transacao-negada-column"
                    onBlur={onBlurCardNumberChange}
                  >
                    <TextField
                      name="NovoCartaoNumero"
                      disabled={boletoHabilitado}
                      placeholder="Número do cartão"
                      value={creditCardData.NovoCartaoNumero}
                      maxlength={maxLengthCardNumber()}
                      error={inputErrors.NovoCartaoNumero}
                      pedidoNegado
                      onChange={(e) => {
                        onChangeCreditCard(
                          formatCardNumber(e.target.value.replace(/\s+/g, '')),
                          'NovoCartaoNumero'
                        )
                        setCardFlag(getCardFlag(e.target.value))
                      }}
                    />
                  </S.TransacaoNegadaNegadaColum>
                </S.TransacaoNegadaNegadaColums>
                <S.TransacaoNegadaNegadaColums classname="transacao-negada-columns">
                  <S.TransacaoNegadaNegadaColum className="transacao-negada-column">
                    <strong>Validade:</strong>
                  </S.TransacaoNegadaNegadaColum>

                  <div className="selectValidade">
                    <S.TransacaoNegadaNegadaColum>
                      <Select
                        date
                        id="mesValidade"
                        disabled={boletoHabilitado}
                        name="mesValidade"
                        className="form-select"
                        pedidoNegado
                        // options={Object.entries(arrayMonths).map((item) => {
                        //   return {
                        //     value: item[0],
                        //     label: item[1]
                        //   }
                        // })}
                        options={monthsList(creditCardData.anoValidade)}
                        labelFor="mesValidade"
                        value={creditCardData.mesValidade}
                        onChange={(e) => {
                          // onChange(e.target.value, 'mesValidade')
                          setCreditCardData({
                            ...creditCardData,
                            mesValidade: e.target.value
                          })
                        }}
                        error={
                          creditCardData.mesValidade === undefined &&
                          inputErrors.mesValidade
                        }
                      />
                    </S.TransacaoNegadaNegadaColum>

                    <S.TransacaoNegadaNegadaColum>
                      <Select
                        date
                        id="anoValidade"
                        disabled={boletoHabilitado}
                        name="anoValidade"
                        className="form-select"
                        pedidoNegado
                        // options={[...range(2021, 2040)].map((item) => {
                        //   return {
                        //     value: item,
                        //     label: item
                        //   }
                        // })}
                        options={yearsList(10)}
                        labelFor="anoValidade"
                        value={creditCardData.anoValidade}
                        onChange={(e) =>
                          // onChange(e.target.value, 'anoValidade')
                          setCreditCardData({
                            ...creditCardData,
                            anoValidade: e.target.value
                          })
                        }
                        error={
                          creditCardData.anoValidade === undefined &&
                          inputErrors.anoValidade
                        }
                      />
                    </S.TransacaoNegadaNegadaColum>
                  </div>
                </S.TransacaoNegadaNegadaColums>
                <S.TransacaoNegadaNegadaColums classname="transacao-negada-columns">
                  <S.TransacaoNegadaNegadaColum className="transacao-negada-column">
                    <strong>Código de Segurança:</strong>
                  </S.TransacaoNegadaNegadaColum>
                  <S.TransacaoNegadaNegadaColum className="transacao-negada-column">
                    <TextField
                      name="CartaoCodigoSeguranca"
                      disabled={boletoHabilitado}
                      maxLength={4}
                      id="CartaoCodigoSeguranca"
                      placeholder="Código de Segurança"
                      value={creditCardData.CartaoCodigoSeguranca}
                      error={inputErrors.CartaoCodigoSeguranca}
                      onChange={handleCVVChange}
                      className="form-input"
                      pedidoNegado
                    />
                  </S.TransacaoNegadaNegadaColum>
                </S.TransacaoNegadaNegadaColums>
              </S.TransacaoNegadaContent>

              <S.TransacaoNegadaContent className="transacao-negada-content">
                <S.TransacaoNegadaSubTitleBox className="transacao-negada-subtitle-box">
                  <S.TransacaoNegadaSubTitleH5 className="transacao-negada-subtitle">
                    Informações de Transação
                  </S.TransacaoNegadaSubTitleH5>
                </S.TransacaoNegadaSubTitleBox>

                <S.TransacaoNegadaNegadaColums class="transacao-negada-columns">
                  <S.TransacaoNegadaNegadaColum class="transacao-negada-column">
                    <strong>Data Pagamento Rejeitado:</strong>
                  </S.TransacaoNegadaNegadaColum>
                  <S.TransacaoNegadaNegadaColum class="transacao-negada-column">
                    <p class="description">
                      {localData.CartaoDataPagamentoRejeitado}
                    </p>
                  </S.TransacaoNegadaNegadaColum>
                </S.TransacaoNegadaNegadaColums>

                <S.TransacaoNegadaNegadaColums class="transacao-negada-columns">
                  <S.TransacaoNegadaNegadaColum class="transacao-negada-column">
                    <strong>Mensagem Operadadora TEF:</strong>
                  </S.TransacaoNegadaNegadaColum>
                  <S.TransacaoNegadaNegadaColum class="transacao-negada-column">
                    <p class="description">{localData.CartaoMensagemDtef}</p>
                  </S.TransacaoNegadaNegadaColum>
                </S.TransacaoNegadaNegadaColums>
                <S.TransacaoNegadaNegadaColums class="transacao-negada-columns">
                  <S.TransacaoNegadaNegadaColum class="transacao-negada-column">
                    <strong>Número/Valor de Parcelas:</strong>
                  </S.TransacaoNegadaNegadaColum>
                  <S.TransacaoNegadaNegadaColum class="transacao-negada-column">
                    <p class="description">
                      {localData.CartaoQuantidadeParcelas &&
                        localData.CartaoValorParcela &&
                        localData.CartaoQuantidadeParcelas +
                          ' / ' +
                          convertDecimalCurrency(localData.CartaoValorParcela)}
                    </p>
                  </S.TransacaoNegadaNegadaColum>
                </S.TransacaoNegadaNegadaColums>
                <S.TransacaoNegadaNegadaColums class="transacao-negada-columns">
                  <S.TransacaoNegadaNegadaColum class="transacao-negada-column">
                    <strong>Valor do Acréscimo Financeiro (A):</strong>
                  </S.TransacaoNegadaNegadaColum>
                  <S.TransacaoNegadaNegadaColum class="transacao-negada-column">
                    <p class="description">
                      {localData.CartaoAcrescimoFinanceiro &&
                        `${convertDecimalCurrency(
                          localData.CartaoAcrescimoFinanceiro
                        )}`}
                    </p>
                  </S.TransacaoNegadaNegadaColum>
                </S.TransacaoNegadaNegadaColums>

                <S.TransacaoNegadaNegadaColums class="transacao-negada-columns">
                  <S.TransacaoNegadaNegadaColum class="transacao-negada-column">
                    <strong>Valor do ST (B):</strong>
                  </S.TransacaoNegadaNegadaColum>
                  <S.TransacaoNegadaNegadaColum class="transacao-negada-column">
                    <S.PerfilBoxP class="description">
                      {localData.ValorST &&
                        `${convertDecimalCurrency(localData.ValorST)}`}
                    </S.PerfilBoxP>
                  </S.TransacaoNegadaNegadaColum>
                </S.TransacaoNegadaNegadaColums>
                <S.TransacaoNegadaNegadaColums class="transacao-negada-columns">
                  <S.TransacaoNegadaNegadaColum class="transacao-negada-column">
                    <strong>Valor do Frete (C):</strong>
                  </S.TransacaoNegadaNegadaColum>
                  <S.TransacaoNegadaNegadaColum class="transacao-negada-column">
                    <S.PerfilBoxP class="description">
                      {localData.CartaoValorFrete &&
                        `${convertDecimalCurrency(localData.CartaoValorFrete)}`}
                    </S.PerfilBoxP>
                  </S.TransacaoNegadaNegadaColum>
                </S.TransacaoNegadaNegadaColums>
                <S.TransacaoNegadaNegadaColums class="transacao-negada-columns">
                  <S.TransacaoNegadaNegadaColum class="transacao-negada-column">
                    <strong>Valor dos Produtos (D):</strong>
                  </S.TransacaoNegadaNegadaColum>
                  <S.TransacaoNegadaNegadaColum class="transacao-negada-column">
                    <S.PerfilBoxP class="description">
                      {localData.CartaoValorProdutos &&
                        `${convertDecimalCurrency(
                          localData.CartaoValorProdutos
                        )}`}

                      {/* {
                                localData.CartaoValorProdutos &&
                                (`R$ ${parseInt(localData.CartaoValorDescontoProdutos) > 0 &&
                                    <> (com desconto de R$ {localData.CartaoValorDescontoProdutos} já aplicado) </>}`)

                                } */}
                    </S.PerfilBoxP>
                  </S.TransacaoNegadaNegadaColum>
                </S.TransacaoNegadaNegadaColums>

                <S.TransacaoNegadaNegadaColums class="transacao-negada-columns">
                  <S.TransacaoNegadaNegadaColum class="transacao-negada-column">
                    <strong>Valor do Desconto (E):</strong>
                  </S.TransacaoNegadaNegadaColum>
                  <S.TransacaoNegadaNegadaColum class="transacao-negada-column">
                    <S.PerfilBoxP class="description">
                      {localData.CartaoValorDesconto &&
                        `${convertDecimalCurrency(
                          localData.CartaoValorDesconto
                        )}`}
                    </S.PerfilBoxP>
                  </S.TransacaoNegadaNegadaColum>
                </S.TransacaoNegadaNegadaColums>

                <S.TransacaoNegadaNegadaColums class="transacao-negada-columns">
                  <S.TransacaoNegadaNegadaColum class="transacao-negada-column">
                    <strong>Valor do Pedido (A+B+C+D-E):</strong>
                  </S.TransacaoNegadaNegadaColum>
                  <S.TransacaoNegadaNegadaColum class="transacao-negada-column">
                    <S.PerfilBoxP class="description">
                      {localData.CartaoValorPedido &&
                        `${convertDecimalCurrency(
                          localData.CartaoValorPedido
                        )}`}
                    </S.PerfilBoxP>
                  </S.TransacaoNegadaNegadaColum>
                </S.TransacaoNegadaNegadaColums>
              </S.TransacaoNegadaContent>
              {localData.IdEntregaExpressa === 0 &&
                localData.FilialPrincipal === 'S' && (
                  <S.TransacaoNegadaContent className="transacao-negada-content">
                    <S.TransacaoNegadaSubTitleBox className="transacao-negada-subtitle-box">
                      <S.TransacaoNegadaSubTitleH5 className="transacao-negada-subtitle">
                        Alterar Forma de Pagamento
                      </S.TransacaoNegadaSubTitleH5>
                    </S.TransacaoNegadaSubTitleBox>
                    <strong className="text-color-primary">
                      Caso queira mudar a forma de pagamento, selecione uma
                      opção abaixo.
                    </strong>
                    <S.TransacaoNegadaNegadaColums className="transacao-negada-columns">
                      <S.TransacaoNegadaNegadaColum className="transacao-negada-column"></S.TransacaoNegadaNegadaColum>

                      <S.TransacaoNegadaNegadaColum className="transacao-negada-column">
                        <input
                          onChange={(e) => {
                            handleChangeCheckbox(e, 'BoletoAVista')
                            handleBoletoAVistaChange()
                          }}
                          checked={BoletoAVistaHabilitado}
                          type="checkbox"
                          value={BoletoAVistaHabilitado}
                          id="BoletoAVista"
                          name="BoletoAVista"
                        />

                        <label for="BoletoAVista">
                          <S.b>Boleto à vista</S.b>
                        </label>
                      </S.TransacaoNegadaNegadaColum>
                    </S.TransacaoNegadaNegadaColums>

                    <S.TransacaoNegadaNegadaColums className="transacao-negada-columns">
                      <S.TransacaoNegadaNegadaColum className="transacao-negada-column">
                        <strong>Valor total de desconto:</strong>
                      </S.TransacaoNegadaNegadaColum>

                      <S.TransacaoNegadaNegadaColum className="transacao-negada-column">
                        <p className="description" style={{ marginTop: 0 }}>
                          R$ {localData.BoletoValorDescontoProdutos} (Produtos)
                          + R$ {localData.CartaoValorDesconto} (Outros) + R${' '}
                          {localData.BoletoValorDesconto} (Boleto) = R${' '}
                          {localData.BoletoValorDescontoTotal}
                        </p>
                      </S.TransacaoNegadaNegadaColum>
                    </S.TransacaoNegadaNegadaColums>

                    <S.TransacaoNegadaNegadaColums className="transacao-negada-columns">
                      <S.TransacaoNegadaNegadaColum className="transacao-negada-column">
                        <strong>Valor final do pedido:</strong>
                      </S.TransacaoNegadaNegadaColum>
                      <S.TransacaoNegadaNegadaColum className="transacao-negada-column">
                        <p
                          className="description"
                          style={{ marginTop: 0, marginBottom: 8 }}
                        >
                          {convertDecimalCurrency(localData.BoletoValorPedido)}
                        </p>
                      </S.TransacaoNegadaNegadaColum>
                    </S.TransacaoNegadaNegadaColums>

                    {localData.TipoCliente === 'J' &&
                    !localData.PossuiSplit &&
                    !localData.PossuiSeller ? (
                      <S.TransacaoNegadaNegadaColums className="transacao-negada-columns">
                        <S.TransacaoNegadaNegadaColum
                          className="transacao-negada-column"
                          style={{ alignSelf: 'self-end' }}
                        >
                          <strong
                            className="text-color-primary"
                            style={{ marginBottom: 8 }}
                          >
                            Selecione:
                          </strong>
                        </S.TransacaoNegadaNegadaColum>

                        <S.TransacaoNegadaNegadaColum className="transacao-negada-column">
                          <div className="form-group">
                            <input
                              onChange={(e) => {
                                // console.log('e', e)
                                handleChangeCheckbox(e, 'BoletoFaturadoCheck')
                              }}
                              checked={BoletoFaturadoHabilitado}
                              type="checkbox"
                              value={BoletoFaturadoHabilitado}
                              id="BoletoFaturadoCheck"
                              name="BoletoFaturadoCheck"
                            />

                            <label for="BoletoFaturadoCheck">
                              <S.b>Boleto Faturado</S.b>
                            </label>
                          </div>

                          <Select
                            name="boletoFaturadoValues"
                            onChange={(e) => {
                              setBoletoFaturadoValue(e.target.value)

                              handleBoletoFaturadoChange(e.target.value)
                            }}
                            value={boletoFaturadoValue}
                            options={boletoFaturadoOptions}
                            style={{ width: '220px' }}
                          />
                        </S.TransacaoNegadaNegadaColum>
                      </S.TransacaoNegadaNegadaColums>
                    ) : null}
                  </S.TransacaoNegadaContent>
                )}
            </S.PerfilBox>

            <S.TransacaoNegadaFooter className="transacao-negada-footer">
              <S.Button
                type="button"
                onClick={() => {
                  if (!boletoHabilitado) {
                    handleSubmitCredit()
                    // console.log('card')
                  } else {
                    openModal()
                    // console.log('bol')
                  }
                  // salvarDados()
                }}
                className={'button button-primary'}
              >
                Confirmar
              </S.Button>
              <S.ButtonBack
                onClick={() => {
                  history.push(`/meus-pedidos`, {
                    redirect: false
                  })
                }}
                className="button button-back"
              >
                Voltar
              </S.ButtonBack>
            </S.TransacaoNegadaFooter>
          </S.Wrapper>
        </S.PageContent>
        <div class="no-desk">
          <button class="scroll-top js-scroll-top"></button>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default DadosPagamento
